import { Icon } from "components/common";
import {
  COMMUNITY_FEED,
  COMMUNITY_LEADERBOARD,
  COMMUNITY_PEOPLE,
  COMMUNITY_ROOT,
} from "constants/app-paths";

export const getMenuItems = () => {
  return [
    {
      key: "/dashboard",
      icon: <Icon icon="MdOutlineDashboard" />,
      label: "Dashboard",
    },
    {
      key: `/presentation`,
      icon: <Icon icon="FiMonitor" />,
      label: "Lectures",
    },
    {
      key: `/scripts`,
      icon: <Icon icon="BsFileEarmarkText" />,
      label: "Scripts",
      subPaths: [
        {
          key: `/scripts`,
          label: "All Scripts",
        },
        {
          key: `/scripts/favorite-scripts`,
          label: "My Favorites",
        },
        {
          key: `/scripts/editedpages`,
          label: "Edited",
        },
        {
          key: `/scripts/hiddenpages`,
          label: "Hidden",
        },
      ],
    },
    {
      key: `/tests`,
      icon: <Icon icon="MdQuiz" />,
      label: "Tests",
      subPaths: [
        {
          key: `/tests`,
          label: "All Tests",
        },
        {
          key: `/tests/questions`,
          label: "Questions Library",
        },
        // {
        //   key: `/tests/importedquestions`,
        //   label: "Imported Questions",
        // },
        {
          key: `/tests/answered-questions`,
          label: "Answered Questions",
        },
      ],
    },
    {
      key: COMMUNITY_ROOT,
      icon: <Icon icon="FiUsers" />,
      label: "Community",
      subPaths: [
        {
          key: COMMUNITY_FEED,
          label: "Feed",
        },
        {
          key: COMMUNITY_PEOPLE,
          label: "Find People",
        },
        {
          key: COMMUNITY_LEADERBOARD,
          label: "Leaderboard",
        },
      ],
    },
    {
      key: `/template-settings`,
      icon: <Icon icon="MdOutlineSettings" />,
      label: "Template Settings",
    },
    {
      key: `/script-feedback`,
      icon: <Icon icon="VscFeedback" />,
      label: "Feedback",
    },
    {
      key: `/analytics`,
      icon: <Icon icon="MdPieChart" />,
      label: "Analytics",
      subPaths: [
        { key: `/analytics/specialty`, label: "By Specialty" },
        { key: `/analytics/script`, label: "By Script" },
        { key: `/analytics/topic`, label: "By Topic" },
        { key: `/analytics/explanation`, label: "By Explanation" },
      ],
    },
    {
      key: `/app-users`,
      icon: <Icon icon="FiUsers" />,
      label: "Users",
    },
    {
      key: `/accounts`,
      icon: <Icon icon="MdOutlineManageAccounts" />,
      label: "Account Setting",
    },
    {
      key: `/contactus`,
      icon: <Icon icon="HiOutlineMail" />,
      label: "Contact Us",
    },
  ];
};
